import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["stored", "upload", "remove", "file"];

  remove() {
    this.removeTarget.value = "1";
    this.storedTarget.hidden = true;
    this.uploadTarget.hidden = false;
    this.fileTarget.disabled = false;
  }

  replace() {
    this.removeTarget.value = this.fileTarget.files.length ? "0" : "1";
  }
}
